// export const global = {
//   namedspace: true,
//   modules: {
//     user: userState,
//     settings: settingsState,
//     app:appStore
//   }
// };

// export default global;
/**
 * Automatically imports all the modules and exports as a single module object
 */
const requireModule = require.context(
  '@/store/modules/global/',
  true,
  /\.store\.ts$/
);

const modules = {};

requireModule.keys().forEach(filename => {
  // create the module name from fileName
  // remove the store.js extension and capitalize
  const moduleName = filename
    .replace(/(\.\/|\\|\.store\.ts)/g, '')
    .replace(/(\/(.*))/g, '')
    .replace(/^\w/, c => c.toLowerCase());
  modules[moduleName] =
    requireModule(filename).default || requireModule(filename);
});
const global = {
  namespaced: true,
  modules: modules
};

export default global;
